import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPolygonGeometry,
    PolygonGeometry,
    polygonGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import {
    PaddockType,
    paddockTypeSchema,
} from 'app/agriculture/queries/entities/types/infrastructure/PaddockType';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface Paddock extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    paddockType: PaddockType;

    geometry: PolygonGeometry;
    pole: PointGeometry;
}

export const paddockSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    paddockType: paddockTypeSchema,

    geometry: polygonGeometrySchema,
    pole: pointGeometrySchema,
});

export const mockPaddock = ({
    id = 'fae74afe-2142-42cd-b3f8-a24a7795765f',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Paddock Name',
    paddockType = 'Grazing',

    geometry = mockPolygonGeometry(),
    pole = mockPointGeometry(),
}: Partial<Paddock> = {}): Paddock => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,
    paddockType,

    geometry,
    pole,
});
